export enum QueryParamKeys {
  authCode = 'auth_code',
  authUri = 'auth_uri',
  embedded = 'embedded',
  ref = 'ref',
  sessionId = 'sessionId',
  tenantId = 'tenantId',
}
